if (!window.__levelupInit) { window.__levelupInit = true;
// LEVEL UP · redesign interactions
(function () {
  "use strict";

  // progressive enhancement flag: scroll-reveal styles only apply with JS on
  document.body.classList.add("js");

  // Quantity steppers (hero card + pack cards)
  document.querySelectorAll(".qty-ctrl").forEach(function (ctrl) {
    var input = ctrl.querySelector("input");
    ctrl.querySelectorAll("button[data-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = parseInt(btn.dataset.step, 10);
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.min(99, Math.max(1, val + step));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  // Hero buy card price
  var packSelect = document.getElementById("pack-select");
  var qtyInput = document.getElementById("qty");
  var priceEl = document.getElementById("buy-price");

  function updatePrice() {
    if (!packSelect || !qtyInput || !priceEl) return;
    var unit = parseFloat(packSelect.value) || 0;
    var qty = parseInt(qtyInput.value, 10) || 1;
    priceEl.textContent = "$" + (unit * qty).toFixed(2);
  }
  if (packSelect) packSelect.addEventListener("change", updatePrice);
  if (qtyInput) qtyInput.addEventListener("change", updatePrice);
  updatePrice();

  // Mobile nav
  var nav = document.querySelector(".main-nav");
  var toggles = document.querySelectorAll(".nav-toggle, .nav-close-btn");

  if (nav && toggles.length > 0) {
    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var isOpen = nav.classList.toggle("open");
        
        toggles.forEach(function (t) {
          if (t.hasAttribute("aria-expanded")) {
            t.setAttribute("aria-expanded", isOpen ? "true" : "false");
          }
        });
      });
    });

    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("open");
        toggles.forEach(function (t) {
          if (t.hasAttribute("aria-expanded")) {
            t.setAttribute("aria-expanded", "false");
          }
        });
      });
    });
  }



  // Scroll reveal (compare board rows: once)
  var toReveal = document.querySelectorAll(".comp-row");
  if ("IntersectionObserver" in window && toReveal.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    toReveal.forEach(function (el) { obs.observe(el); });
  } else {
    toReveal.forEach(function (el) { el.classList.add("in-view"); });
  }

  // Packs section: re-triggering entrance animation
  var packsSection = document.getElementById("packs");
  if (packsSection && "IntersectionObserver" in window) {
    var packsObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        packsSection.classList.toggle("in-view", entry.isIntersecting);
      });
    }, { threshold: 0.25 });
    packsObs.observe(packsSection);
  } else if (packsSection) {
    packsSection.classList.add("in-view");
  }

  // Auto carousels (packs, reviews): exact cards per view, auto-advance
  document.querySelectorAll(".packs-carousel").forEach(function (root) {
    var viewport = root.querySelector(".packs-viewport");
    var track = root.querySelector(".packs-grid");
    if (!viewport || !track) return;

    var paused = false;
    var visible = false;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var GAP = 24;

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible = e.isIntersecting; });
      }, { threshold: 0.2 }).observe(root);
    } else {
      visible = true;
    }

    // size cards so an exact number fits per view: no chopped cards
    function sizeCards() {
      var cs = getComputedStyle(viewport);
      var inner = viewport.clientWidth -
        parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var n = window.innerWidth > 1080 ? 3 : window.innerWidth > 700 ? 2 : 1;
      var w = Math.floor((inner - GAP * (n - 1)) / n);
      Array.prototype.forEach.call(track.children, function (c) {
        c.style.flex = "0 0 " + w + "px";
      });
    }
    sizeCards();
    window.addEventListener("resize", sizeCards);

    function cardStep() {
      var card = track.children[0];
      if (!card) return 300;
      return card.getBoundingClientRect().width + GAP;
    }
    function autoAdvance() {
      if (paused || !visible || reduced) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (viewport.scrollLeft >= maxScroll - 10) {
        viewport.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        viewport.scrollBy({ left: cardStep(), behavior: "smooth" });
      }
    }
    setInterval(autoAdvance, 3800);

    ["mouseenter", "touchstart", "focusin", "pointerdown"].forEach(function (ev) {
      viewport.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ["mouseleave", "focusout"].forEach(function (ev) {
      viewport.addEventListener(ev, function () { paused = false; });
    });
    viewport.addEventListener("touchend", function () {
      setTimeout(function () { paused = false; }, 6000);
    }, { passive: true });

    var prev = root.querySelector(".pk-prev");
    var next = root.querySelector(".pk-next");
    function manualScroll(dir) {
      paused = true;
      viewport.scrollBy({ left: dir * cardStep(), behavior: "smooth" });
      setTimeout(function () { paused = false; }, 6000);
    }
    if (prev) prev.addEventListener("click", function () { manualScroll(-1); });
    if (next) next.addEventListener("click", function () { manualScroll(1); });
  });

  // Generic re-triggering section reveals (ingredients, story)
  var revealSections = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && revealSections.length) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle("in-view", entry.isIntersecting);
      });
    }, { threshold: 0.25 });
    revealSections.forEach(function (sec) { revObs.observe(sec); });
  } else {
    revealSections.forEach(function (sec) { sec.classList.add("in-view"); });
  }

  // Story trio: bottles rotate positions, the center one grows
  var trio = document.querySelector(".story-trio");
  if (trio) {
    var trioBottles = trio.querySelectorAll(".trio-b");
    var trioOffset = 0;
    var trioReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function applyTrioSlots() {
      trioBottles.forEach(function (b, i) {
        var slot = (i + trioOffset) % 3;
        b.classList.remove("slot-0", "slot-1", "slot-2");
        b.classList.add("slot-" + slot);
      });
    }
    applyTrioSlots();

    if (!trioReduced) {
      setInterval(function () {
        var sec = document.getElementById("story");
        if (sec && !sec.classList.contains("in-view")) return;
        trioOffset = (trioOffset + 2) % 3;
        applyTrioSlots();
      }, 2600);
    }
  }

  // Nutrition label: typewriter reveal, re-triggered on each entry
  var nutrition = document.getElementById("nutrition");
  if (nutrition && "IntersectionObserver" in window) {
    var nutObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        nutrition.classList.toggle("in-view", entry.isIntersecting);
      });
    }, { threshold: 0.3 });
    nutObs.observe(nutrition);
  } else if (nutrition) {
    nutrition.classList.add("in-view");
  }

  // CTA band: 3D tilt of the product photo following the cursor
  var band = document.getElementById("cta");
  var bottle = document.getElementById("cta-bottle");
  var fine = window.matchMedia("(pointer: fine)").matches;
  var noMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (band && bottle && fine && !noMotion) {
    var tX = 0, tY = 0, curX = 0, curY = 0, rafId = null;

    function tiltFrame() {
      rafId = null;
      curX += (tX - curX) * 0.12;
      curY += (tY - curY) * 0.12;
      bottle.style.transform =
        "rotateY(" + curX.toFixed(2) + "deg) rotateX(" + curY.toFixed(2) + "deg) rotateZ(8deg)";
      if (Math.abs(tX - curX) > 0.05 || Math.abs(tY - curY) > 0.05) {
        rafId = requestAnimationFrame(tiltFrame);
      }
    }
    function kick() { if (!rafId) rafId = requestAnimationFrame(tiltFrame); }

    band.addEventListener("mousemove", function (e) {
      var r = band.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      tX = px * 28;
      tY = -py * 16;
      kick();
    });
    band.addEventListener("mouseleave", function () {
      tX = 0; tY = 0;
      kick();
    });
  }

  // Newsletter (demo only)
  var form = document.querySelector(".newsletter-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("button");
      btn.textContent = "Subscribed ✓";
      btn.disabled = true;
    });
  }
})();

}
